import { useDndContext } from "@dnd-kit/core";
import { useTranslation } from "@/packages/utils";

interface BoardEmptyColumnProps {
  visible: boolean;
  columnId?: string;
}

export function BoardEmptyColumn({ visible, columnId }: BoardEmptyColumnProps) {
  const { active, over } = useDndContext();
  const isOver = !!columnId && !!over && String(over.id) === columnId;
  const { t } = useTranslation(["common"]);
  const show = visible && !!active;

  return (
    <div
      className="relative flex items-center justify-center min-h-[80px] flex-1 rounded-xl border-2 border-dashed transition-all duration-150"
      style={{
        opacity: show ? 1 : 0,
        borderColor: show ? (isOver ? "#3B82F6" : "#48484A") : "transparent",
        backgroundColor:
          show && isOver ? "rgba(59, 130, 246, 0.08)" : "transparent",
        pointerEvents: show ? "auto" : "none",
      }}
    >
      <span
        className="text-sm transition-colors duration-150"
        style={{ color: show && isOver ? "#3B82F6" : "#6C6C70" }}
      >
        {t("board.dropHere")}
      </span>
    </div>
  );
}
